<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" [appendTo]="'body'" [styleClass]="'product-order-dialog'">
  <ng-template pTemplate="header">
    <div class="dialog-header" [attr.data-subtitle]="'productsCrud.order.description' | transloco">
      <span class="dialog-title">{{ 'productsCrud.order.title' | transloco }}</span>
    </div>
  </ng-template>

  <div class="order-content">
    <app-select
      [label]="'productsCrud.order.platform' | transloco"
      [placeholder]="'productsCrud.fields.platformPlaceholder' | transloco"
      [options]="platformOptions"
      [ngModel]="platformId"
      (ngModelChange)="onPlatformChange($event)"
      size="medium"
      [appendTo]="null"
    ></app-select>

    <!-- Fixed-height area: loading, empty and the list take the same room, nothing jumps -->
    <div class="order-list-area">
    @if (isLoading) {
      <div class="order-list">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <p-skeleton height="48px"></p-skeleton>
        }
      </div>
    } @else if (items.length === 0) {
      <p class="order-empty">{{ 'productsCrud.order.empty' | transloco }}</p>
    } @else {
      <div class="order-list" cdkDropList (cdkDropListDropped)="drop($event)">
        @for (item of items; track item.id; let i = $index) {
          <div class="order-item" cdkDrag cdkDragLockAxis="y">
            <span class="order-handle" cdkDragHandle>
              <lucide-icon name="GripVertical" [size]="18"></lucide-icon>
            </span>
            <span class="order-position">{{ i + 1 }}</span>
            <span class="order-name">{{ item.name }}</span>
          </div>
        }
      </div>
    }
    </div>

    <div class="form-actions">
      <app-button
        [label]="'common.actions.save' | transloco"
        size="medium"
        [disabled]="isSaving || isLoading || items.length === 0"
        [loading]="isSaving"
        (onClick)="save()"
      ></app-button>
    </div>
  </div>
</p-dialog>
